import styled from '@emotion/styled'
import { Divider as MuiDivider } from '@mui/material'

export const Divider = styled(MuiDivider)`
  width: 100%;
  height: 1px;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 25%);
  margin: ${({ theme }) => theme.spacing(1, 0)};
  border: none;
`
